/* eslint-disable react/prop-types */
// Argon Dashboard 2 MUI components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonAvatar from "components/ArgonAvatar";
import ArgonBadge from "components/ArgonBadge";

import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import ArgonButton from "components/ArgonButton";

// Images
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import team4 from "assets/images/team-4.jpg";
import { Link } from "react-router-dom";

function Author({ image, name, email }) {
 
  return (
    <ArgonBox display="flex" alignItems="center" px={0.5} py={0.1}>
      <ArgonBox mr={2}>
        <ArgonAvatar src={image} alt={name} size="sm" variant="full"/>
      </ArgonBox>
      <ArgonBox display="flex" flexDirection="column">
        <ArgonTypography variant="button" fontWeight="medium">
          {name}
        </ArgonTypography>
        <ArgonTypography variant="caption" color="secondary">
          {email}
        </ArgonTypography>
      </ArgonBox>
    </ArgonBox>
  );
}

function Function({ job, org }) {
  return (
    <ArgonBox display="flex" flexDirection="column">
      <ArgonTypography variant="caption" fontWeight="medium" color="text">
        {job}
      </ArgonTypography>
      <ArgonTypography variant="caption" color="secondary">
        {org}
      </ArgonTypography>
    </ArgonBox>
  );
}

function StudentData({student,client}){
    return(
      <ArgonBox display="flex" flexDirection="column">
        <ArgonTypography variant="caption" color="text" fontWeight="medium">{student}</ArgonTypography>
        <ArgonTypography variant="caption" color="text" fontWeight="medium">Client-{client}</ArgonTypography>
      </ArgonBox>
    )
}

// Attendance component
function AttendanceProgress({ percentage, label = "Attendance" }) {
  return (
    <ArgonBox>
      {/* Label */}
      <ArgonBox display="flex" justifyContent="space-between" mb={1}>
        <ArgonTypography variant="caption" fontWeight="medium" color="text">
          {"12 July 2024"}
        </ArgonTypography>
        
      </ArgonBox>
      
      {/* Progress Bar Container */}
      <ArgonBox
        width="180%"
        height="10px"
        bgColor="grey-200"
        borderRadius="lg"
        position="relative"
        overflow="hidden"
      >
        {/* Progress Fill */}
        <ArgonBox
          width={`${percentage}%`}
          height="100%"
          // bgColor={percentage >= 80 ? "success" : percentage >= 60 ? "warning" : "error"}
          bgColor="primary"
          borderRadius="lg"
          position="absolute"
          top={0}
          left={0}
        />
      </ArgonBox>
    </ArgonBox>
  );
}






const tutorsPayrollTableData = (handleDeleteClick)=>({
  columns: [

    // { name: "author", align: "left" },
    // { name: "function", align: "left" },
    // { name: "status", align: "center" },
    // { name: "employed", align: "center" },
    // { name: "action", align: "center" },

    {name:"sno",align:"center"},
    {name:"tutors",align:"left"},
    {name:"Payroll Status", align:"left"},
    {name:"class name", align:"left"},
    {name:"status", align:"left"},
    {name:"mode", align:"left"},
    {name:"last payment", align:"left"},
    {name:"action",align:"center"},
  ],


  rows: [
  {
    sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">1</ArgonTypography>,
    tutors: <Author image={team2} name="Dr. Priya Patel" email="priya@gmail.com" />,
    "Payroll Status": <ArgonBadge variant="gradient" badgeContent="Processed" color="success" size="xs" container />,
    "class name": <ArgonTypography variant="caption" color="text" fontWeight="medium">Mathematics Grade 10</ArgonTypography>,
    status: <ArgonBadge variant="gradient" badgeContent="Active" color="success" size="xs" container />,
    mode: <ArgonTypography variant="caption" color="text" fontWeight="medium">Bank Transfer</ArgonTypography>,
    "last payment": <ArgonTypography variant="caption" color="text" fontWeight="medium">15 Dec 2024</ArgonTypography>,
    action: (
                    <ArgonBox display="flex" alignItems="center" gap={0}>
                        {/* View Icon */}
                         <ArgonButton variant="text"  size="large" component={Link} to="/tutorpayroll/view" sx={{minWidth:"12px",p:0}} >
                           <VisibilityIcon color="primary"/>
                         </ArgonButton>
                         {/* Delete icon */}
                        <ArgonButton variant="text"  size="large" sx={{minWidth:"32px",p:0}}
                        onClick={() =>handleDeleteClick()} >
                          <DeleteIcon color="error"/>
                        </ArgonButton>
    
                      </ArgonBox>
                    ),
  },
  {
    sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">2</ArgonTypography>,
    tutors: <Author image={team3} name="Prof. Vikash Singh" email="vikash@gmail.com" />,
    "Payroll Status": <ArgonBadge variant="gradient" badgeContent="Pending" color="warning" size="xs" container />,
    "class name": <ArgonTypography variant="caption" color="text" fontWeight="medium">Physics Grade 12</ArgonTypography>,
    status: <ArgonBadge variant="gradient" badgeContent="Active" color="success" size="xs" container />,
    mode: <ArgonTypography variant="caption" color="text" fontWeight="medium">UPI</ArgonTypography>,
    "last payment": <ArgonTypography variant="caption" color="text" fontWeight="medium">10 Dec 2024</ArgonTypography>,
    action: (
      <ArgonBox display="flex" alignItems="center" gap={1}>
        <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
          <VisibilityIcon/>
        </ArgonTypography>
        <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
          <DeleteIcon/>
        </ArgonTypography>
      </ArgonBox>
    ),
  },
  {
    sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">3</ArgonTypography>,
    tutors: <Author image={team4} name="Dr. Sneha Gupta" email="sneha@gmail.com" />,
    "Payroll Status": <ArgonBadge variant="gradient" badgeContent="Failed" color="error" size="xs" container />,
    "class name": <ArgonTypography variant="caption" color="text" fontWeight="medium">Chemistry Grade 11</ArgonTypography>,
    status: <ArgonBadge variant="gradient" badgeContent="Inactive" color="secondary" size="xs" container />,
    mode: <ArgonTypography variant="caption" color="text" fontWeight="medium">Cheque</ArgonTypography>,
    "last payment": <ArgonTypography variant="caption" color="text" fontWeight="medium">05 Dec 2024</ArgonTypography>,
    action: (
      <ArgonBox display="flex" alignItems="center" gap={1}>
        <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
          <VisibilityIcon/>
        </ArgonTypography>
        <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
          <DeleteIcon/>
        </ArgonTypography>
      </ArgonBox>
    ),
  },
   {
    sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">3</ArgonTypography>,
    tutors: <Author image={team4} name="Dr. Sneha Gupta" email="sneha@gmail.com" />,
    "Payroll Status": <ArgonBadge variant="gradient" badgeContent="Failed" color="error" size="xs" container />,
    "class name": <ArgonTypography variant="caption" color="text" fontWeight="medium">Chemistry Grade 11</ArgonTypography>,
    status: <ArgonBadge variant="gradient" badgeContent="Inactive" color="secondary" size="xs" container />,
    mode: <ArgonTypography variant="caption" color="text" fontWeight="medium">Cheque</ArgonTypography>,
    "last payment": <ArgonTypography variant="caption" color="text" fontWeight="medium">05 Dec 2024</ArgonTypography>,
    action: (
      <ArgonBox display="flex" alignItems="center" gap={1}>
        <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
          <VisibilityIcon/>
        </ArgonTypography>
        <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
          <DeleteIcon/>
        </ArgonTypography>
      </ArgonBox>
    ),
  },
   {
    sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">3</ArgonTypography>,
    tutors: <Author image={team4} name="Dr. Sneha Gupta" email="sneha@gmail.com" />,
    "Payroll Status": <ArgonBadge variant="gradient" badgeContent="Failed" color="error" size="xs" container />,
    "class name": <ArgonTypography variant="caption" color="text" fontWeight="medium">Chemistry Grade 11</ArgonTypography>,
    status: <ArgonBadge variant="gradient" badgeContent="Inactive" color="secondary" size="xs" container />,
    mode: <ArgonTypography variant="caption" color="text" fontWeight="medium">Cheque</ArgonTypography>,
    "last payment": <ArgonTypography variant="caption" color="text" fontWeight="medium">05 Dec 2024</ArgonTypography>,
    action: (
      <ArgonBox display="flex" alignItems="center" gap={1}>
        <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
          <VisibilityIcon/>
        </ArgonTypography>
        <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
          <DeleteIcon/>
        </ArgonTypography>
      </ArgonBox>
    ),
  },
   {
    sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">3</ArgonTypography>,
    tutors: <Author image={team4} name="Dr. Sneha Gupta" email="sneha@gmail.com" />,
    "Payroll Status": <ArgonBadge variant="gradient" badgeContent="Failed" color="error" size="xs" container />,
    "class name": <ArgonTypography variant="caption" color="text" fontWeight="medium">Chemistry Grade 11</ArgonTypography>,
    status: <ArgonBadge variant="gradient" badgeContent="Inactive" color="secondary" size="xs" container />,
    mode: <ArgonTypography variant="caption" color="text" fontWeight="medium">Cheque</ArgonTypography>,
    "last payment": <ArgonTypography variant="caption" color="text" fontWeight="medium">05 Dec 2024</ArgonTypography>,
    action: (
      <ArgonBox display="flex" alignItems="center" gap={1}>
        <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
          <VisibilityIcon/>
        </ArgonTypography>
        <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
          <DeleteIcon/>
        </ArgonTypography>
      </ArgonBox>
    ),
  },
]

});

export default tutorsPayrollTableData;
